import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import { Icon } from 'antd';

export default function HttpRedirectsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {['warning', 'failed'].includes(result.status) && <HttpRedirectsResult redirectsChain={result.redirects_chain} />}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type HttpRedirectsResultProps = {
    redirectsChain: {
        from: string;
        to: string;
    }[];
};

function HttpRedirectsResult({ redirectsChain }: HttpRedirectsResultProps) {
    return (
        <>
            {redirectsChain.map((url: any, index: number) => (
                <div
                    key={index}
                    className="description-meta inline-flex flex-wrap"
                >
                    <a
                        href={url.from}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {url.from}
                    </a>

                    <span className="gray-label top-margin">
                        <Icon
                            type="arrow-right"
                            className="icon"
                        />
                    </span>

                    <a
                        href={url.to}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {url.to}
                    </a>
                </div>
            ))}
        </>
    );
}
